import { Injectable, signal } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ModalService {

  private modalSubject = new Subject<any>(); //emits the open/close events
  modalState$ = this.modalSubject.asObservable(); // observable for components to listen

  private modalRefs: { [key: string]: DynamicDialogRef | null } = {};

  modalOpen = signal<boolean>(false);

  constructor(private dialogService: DialogService) { }


  openModal(modalName: string, component: any, config: any = {}) {

    const parentContent = document.querySelector('.p-dialog-content');
    const savedScrollTop = parentContent?.scrollTop ?? 0;

    const ref = this.dialogService.open(component, {
      ...config,
      data: config.data || {},
    });

    if (!ref) return;

    this.modalRefs[modalName] = ref;

    const restoreScroll = () => {
      const modalContents = document.querySelectorAll('.p-dialog-content');
      if (modalContents.length > 1) {
        const parentContent = modalContents[modalContents.length - 2] as HTMLElement;

        if (parentContent && savedScrollTop !== undefined) {
          requestAnimationFrame(() => {
            parentContent.scrollTop = savedScrollTop;
          });
        }
      }
    };

    ref.onClose?.subscribe(() => {
      restoreScroll();
      this.modalRefs[modalName] = null;
    });

    ref.onDestroy?.subscribe(() => {
      restoreScroll();
      this.modalRefs[modalName] = null;
    });

    return ref;
  }

  closeModal(modalName: string) {
    const ref = this.modalRefs[modalName];
    if (ref) {
      ref.destroy();
      this.modalRefs[modalName] = null;
    }
  }

  getModalRef(modalName: string): DynamicDialogRef | null {
    return this.modalRefs[modalName] || null;
  }

  logActiveModals() {
    Object.entries(this.modalRefs).forEach(([key, ref]) => {
      // console.log(`- ${key}: ${ref ? 'Open' : 'Close'}`);
    });// there is an example on header component
  }

}

